/**
 * Service Configuration Index
 * 
 * This file provides a central place to configure which auth service to use.
 * Change the import and export to switch authentication providers.
 */

// ============================================
// CHOOSE YOUR AUTH SERVICE HERE
// ============================================

// Option 1: AWS Cognito (Default)
import cognitoAuthService from './cognitoAuthService';
export default cognitoAuthService;

// Option 2: Custom Backend API
// import customAuthService from './customAuthService';
// export default customAuthService;

// Option 3: Your Custom Service
// import myAuthService from './myAuthService';
// export default myAuthService;

// Option 4: Environment-Based Selection
// const authService = process.env.REACT_APP_AUTH_PROVIDER === 'custom' 
//   ? customAuthService 
//   : cognitoAuthService;
// export default authService;
